module.exports = __webpack_public_path__ + "static/media/9.723fb1c1.png";